import { SERVER_URL } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//Services
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
import * as i3 from "./config.service";
export class MissionsService {
    constructor(http, authService, configService) {
        this.http = http;
        this.authService = authService;
        this.configService = configService;
    }
    /**
      * Function to get all mission paginated
      *
      * @author Brayan Garcia (bsgarciac)
      * @param {Integer} limit - Number of results
      * @param {Integer} offset - Page number
      * @returns {Object} - This functions returns a list of the missions
      *
    **/
    getMissions(limit, offset, category, state = 'available', order_by = 'state') {
        const url = SERVER_URL + '/missions/v2/';
        let params = {};
        if (limit)
            params['limit'] = limit;
        if (offset)
            params['offset'] = offset;
        if (category)
            params['category'] = category;
        if (state)
            params['state'] = state;
        if (order_by)
            params['order_by'] = order_by;
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { params, headers }).toPromise();
    }
    /**
      * Function to get the entire data of the mission and its category
      *
      * @author Brayan Garcia (bsgarciac)
      * @param {Integer} mission_id - ID of the respective mission
      * @returns {Object} - This functions returns the entire information of the mission plus Response state
      *
    **/
    getMissionDetail(id) {
        const url = SERVER_URL + '/missions/' + id + '/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    /**
      * Function to create a Response object related with a Player and a Mission
      *
      * @author Brayan Garcia (bsgarciac)
      * @param {Integer} id - ID of the mission of the response
      * @returns {Object} - This functions returns 200 if response was created or 406 if response has been already created
      *
    **/
    startMission(id) {
        const url = SERVER_URL + '/missions/start_mission/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            mission_id: id
        };
        return this.http.post(url, body, headers).toPromise();
    }
    /**
      * Function to delete a Response
      *
      * @author Brayan Garcia (bsgarciac)
      * @param {Integer} id - ID of the mission of the response
      * @returns {Object} - This functions returns 200 if the response was deleted
      *
    **/
    cancelMission(id) {
        const url = SERVER_URL + '/missions/cancel_mission/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            mission_id: id
        };
        return this.http.post(url, body, headers).toPromise();
    }
    /**
      * Function to get all the questions of one Mission
      *
      * @author Brayan Garcia (bsgarciac)
      * @param {Integer} id - ID of the mission
      * @returns {Object} - This functions returns the list of the questions(full information)
      *
    **/
    getMissionQuestions(id) {
        const url = SERVER_URL + '/missions/get_mission_questions/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            mission_id: id
        };
        return this.http.post(url, body, headers).toPromise();
    }
    getMissionAnswers(id, page, objects) {
        const url = SERVER_URL + '/missions/get_mission_player_responses/';
        const headers = this.authService.getSimpleAuthHeaders();
        const params = {
            mission_id: id,
            page: page,
            objects: objects
        };
        return this.http.get(url, { headers, params }).toPromise();
    }
    /**
      * Function to get the missions displayed on Menu
      *
      * @author Brayan Garcia (bsgarciac)
      * @returns {Object} - This functions returns the list of all the missions on menu.
      *
    **/
    getMissiononMenuQuestions() {
        const url = SERVER_URL + '/missions/get_missions_on_menu/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    getMissiononResponseMenuQuestions() {
        const url = SERVER_URL + '/missions/get_missions_responses_on_menu/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    /**
      * Function to create an Answer object
      *
      * @author Brayan Garcia (bsgarciac)
      * @param {Object} response_id - Id of the current response
      * @param {Object} answers - Array of all answers
      * @returns {Promise} - This functions returns 200 if Answer was created
      *
    **/
    uploadAnswers(response_id, answers) {
        const url = SERVER_URL + '/missions/create_mission_answer/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            response_id,
            answers
        };
        return this.http.post(url, body, headers).toPromise();
    }
    /**
      * Function to get all player responses and its state
      *
      * @author Brayan Garcia (bsgarciac)
      * @returns {Promise} - An array with the response information
      *
    **/
    getMyResponses(offset, limit) {
        const url = SERVER_URL + '/missions/get_player_responses/';
        const headers = this.authService.getSimpleAuthHeaders();
        const params = {
            offset,
            limit
        };
        return this.http.get(url, { headers, params }).toPromise();
    }
    /**
      * Function to claim reward
      *
      * @author Brayan Garcia (bsgarciac)
      * @param {Object} mission - Mission object with response information
      * @returns {Promise} - 200 if reward claimed
      *
    **/
    claimReward(mission) {
        const url = SERVER_URL + '/points/claim_reward/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            response_id: mission.response_id,
            mission_id: mission.id
        };
        if (mission.product_reward)
            body['product_id'] = mission.product_reward.id;
        return this.http.post(url, body, headers).toPromise();
    }
    /**
    * Function to validate the answers
    *
    * @author Brayan Garcia (bsgarciac)
    * @param {Object} answers - Array of all answers
    * @param {String} validate_endpoint - Endpoint to make the request that validates the answers
    * @returns {Promise} - This functions returns 200 if the answers are valid
    *
  **/
    validateAnswers(answers, validate_endpoint) {
        const url = SERVER_URL + validate_endpoint;
        const headers = this.authService.getAuthHeaders();
        const body = {
            answers
        };
        return this.http.post(url, body, headers).toPromise();
    }
    // Function to get options of a question from django
    getOptionsDjango(list_url) {
        const url = SERVER_URL + list_url;
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    // Get player ranking
    getPlayerRanking(mission_id) {
        const url = SERVER_URL + '/missions/get_player_ranking/';
        const params = { mission_id };
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers, params }).toPromise();
    }
    /**
     * Obtains the points that are soon to expire from the player
     * @returns {Promise}
     */
    getPointsToExpire() {
        const url = SERVER_URL + '/points/points_to_expire/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    /**
     * Upgrades the level of the player
     * @param data
     * @returns {Promise}
     */
    upgrade_level(data) {
        const url = SERVER_URL + '/points/upgrade_level/';
        const body = {
            data
        };
        const headers = this.authService.getAuthHeaders();
        return this.http.post(url, body, headers).toPromise();
    }
    /**
     * Obtains the points needed to upgrade to the next level
     * @returns {Promise}
     */
    pointsToLevel() {
        const url = SERVER_URL + '/points/points_to_level/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    getLevels() {
        const url = SERVER_URL + '/points/get_levels/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    upgradeLevel(data) {
        const url = SERVER_URL + '/points/upgrade_level/';
        const body = data;
        const headers = this.authService.getAuthHeaders();
        return this.http.post(url, body, headers).toPromise();
    }
    getPlayerGoals(mission_id = null, month = null, year = null) {
        const url = SERVER_URL + '/missions/get_player_goals_status/';
        if (mission_id || month || year) {
            let params = {};
            if (mission_id)
                params.mission_id = mission_id;
            if (month)
                params.month = month;
            if (year)
                params.year = year;
            const headers = this.authService.getSimpleAuthHeaders();
            return this.http.get(url, { headers, params }).toPromise();
        }
        else {
            const headers = this.authService.getAuthHeaders();
            return this.http.get(url, headers).toPromise();
        }
    }
    getPlayerGoalRanking(month = null, year = null) {
        const url = SERVER_URL + '/missions/get_player_goal_ranking/';
        let params = {};
        if (month)
            params.month = month;
        if (year)
            params.year = year;
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers, params }).toPromise();
    }
    getMissionsCategories() {
        const url = SERVER_URL + '/missions/categories-new/';
        const headers = this.authService.getAuthHeaders();
        let resp = this.http.get(url, headers).toPromise();
        return resp;
    }
    getMissionsCategoriesByParent(parentId) {
        const url = SERVER_URL + '/missions/categories-new/';
        const headers = this.authService.getSimpleAuthHeaders();
        let params = {
            parent_id: parentId
        };
        let resp = this.http.get(url, { headers, params }).toPromise();
        return resp;
    }
    getIaActivity(showOnHeader) {
        let queryParams = {};
        if (showOnHeader) {
            queryParams['show_on_header'] = String(showOnHeader);
        }
        const url = SERVER_URL + '/ia_module/ia_activity_by_player/';
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers, params: queryParams }).toPromise();
    }
    getIaTemplate() {
        const url = SERVER_URL + '/ia_module/ia_template_settings/';
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers }).toPromise();
    }
    uploadIaActivity(file, id) {
        const url = SERVER_URL + '/ia_module/ia_response_generator/';
        const headers = this.authService.getSimpleAuthHeaders();
        const data = {
            ia_template_id: id,
            file: file,
            ia_activity_id: 8
        };
        return this.http.post(url, data, { headers }).toPromise();
    }
    resultIaActivity(id, pk, file) {
        const url = SERVER_URL + '/ia_module/validate_ai_result/';
        const headers = this.authService.getSimpleAuthHeaders();
        const data = {
            ia_activity_id: id,
            pk,
            uploaded_file: file
        };
        console.debug('Data to validate IA result:', data);
        return this.http.post(url, data, { headers }).toPromise();
    }
    generateToken(ia_template_id) {
        const url = SERVER_URL + '/ia_module/generate_ia_token/';
        const headers = this.authService.getSimpleAuthHeaders();
        const data = {
            ia_template_id: ia_template_id
        };
        return this.http.post(url, data, { headers }).toPromise();
    }
    externalprocess(token, image, pdf) {
        const url = 'https://ai.megaincentivos.com/external/process/v2';
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        let data = {};
        let file_extension;
        if (image) {
            const match = image.match(/data:(.*?);base64/);
            const mimeType = match[1];
            file_extension = mimeType.split("/")[1];
            data['file_type'] = "image";
            data['file_extension'] = file_extension;
        }
        else if (pdf) {
            const match = pdf.match(/data:(.*?);base64/);
            const mimeType = match[1];
            file_extension = mimeType.split("/")[1];
            data['file_type'] = "pdf";
            data['file_extension'] = file_extension;
        }
        return this.http.post(url, data, { headers }).toPromise();
    }
    saveFile(url, file, content_type) {
        const headers = {
            'Content-Type': content_type
        };
        return this.http.put(url, file, { headers }).toPromise();
    }
    getIaResponse(iaToken, iaPk) {
        const url = `https://ai.megaincentivos.com/process/${iaPk}`;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${iaToken}`
            })
        };
        return this.http.get(url, httpOptions).toPromise().then((data) => {
            return data;
        });
    }
    generateTokenSaveFileV2(ia_template_id, file) {
        const url = SERVER_URL + '/ia_module/get_response_ia_v2/';
        const headers = this.authService.getSimpleAuthHeaders();
        const data = {
            ia_template_id: ia_template_id,
            file: file
        };
        return this.http.post(url, data, { headers }).toPromise();
    }
    externalProcessV2(object_key, request_id) {
        const url = `https://api.ai.inkremental.co/model-executor/requests/${request_id}/uploaded/`;
        const data = {
            object_key: object_key
        };
        return this.http.post(url, data).toPromise();
    }
    getIaResponseV2(request_id) {
        const url = `https://api.ai.inkremental.co/model-executor/requests/${request_id}/`;
        return this.http.get(url).toPromise();
    }
    waitForResponseV2(requestId) {
        return new Promise((resolve, reject) => {
            let currentErrorCount = 0;
            const interval = setInterval(() => {
                this.getIaResponseV2(requestId).then((data) => {
                    // console.log("data wait for res", data)
                    if (data.status === 'COMPLETED') {
                        clearInterval(interval);
                        resolve(data);
                    }
                    else if (data.status === 'FAILED') {
                        clearInterval(interval);
                        reject(data);
                    }
                }).catch((error) => {
                    clearInterval(interval);
                    // reject(error);
                    currentErrorCount += 1;
                    if (currentErrorCount >= 5) {
                        reject(error);
                    }
                });
            }, 1000);
        });
    }
    saveResponseV2(id_activity, file, request_id, state, additional_answers) {
        const url = SERVER_URL + '/ia_module/save_response/';
        const headers = this.authService.getSimpleAuthHeaders();
        const data = {
            ia_activity_id: id_activity,
            file: file,
            state: state,
            pk: request_id,
            additional_answers: additional_answers
        };
        console.debug('Data to save IA response:', data);
        console.debug('IA response state:', state);
        return this.http.post(url, data, { headers }).toPromise();
    }
    waitForResponse(iaToken, iaPk) {
        return new Promise((resolve, reject) => {
            let currentErrorCount = 0;
            const interval = setInterval(() => {
                this.getIaResponse(iaToken, iaPk).then((data) => {
                    if (data.state === 'success') {
                        clearInterval(interval);
                        resolve(data);
                    }
                    else if (data.state === 'error') {
                        clearInterval(interval);
                        reject(data);
                    }
                }).catch((error) => {
                    clearInterval(interval);
                    // reject(error);
                    currentErrorCount += 1;
                    if (currentErrorCount >= 5) {
                        reject(error);
                    }
                });
            }, 1000);
        });
    }
    saveResponse(id_activity, file, pk, state, additional_answers) {
        const url = SERVER_URL + '/ia_module/save_response/';
        const headers = this.authService.getSimpleAuthHeaders();
        const data = {
            ia_activity_id: id_activity,
            file: file,
            state: state,
            pk: pk.pk || pk,
            additional_answers: additional_answers
        };
        console.debug('Data to save IA response:', data);
        console.debug('IA response state:', state, pk);
        return this.http.post(url, data, { headers }).toPromise();
    }
    get_results() {
        const url = SERVER_URL + '/ia_module/get_bill_info/';
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers }).toPromise();
    }
    validatedocumentDuratex(cedula) {
        const url = SERVER_URL + '/integrations/check-carpintero/';
        const headers = this.authService.getSimpleAuthHeaders();
        const data = {
            cedula: cedula
        };
        return this.http.post(url, data, { headers }).toPromise();
    }
    getReferralsInfo() {
        const url = SERVER_URL + '/crm/referrals/';
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers }).toPromise();
    }
    getIaResultsResume({ template_id, // obligatorio
    ia_activity_id = null, start_date = null, end_date = null, nextPage = null, month = null, year = null, search_term = null }) {
        let url;
        if (nextPage) {
            url = nextPage;
        }
        else {
            url = SERVER_URL + '/ia_module/get_resume_of_results/';
        }
        const headers = this.authService.getSimpleAuthHeaders();
        let params = {
            template_id: template_id
        };
        if (ia_activity_id)
            params['ia_activity_id'] = ia_activity_id;
        if (start_date)
            params['start_date'] = start_date;
        if (end_date)
            params['end_date'] = end_date;
        if (month && year) {
            params['month'] = month;
            params['year'] = year;
        }
        if (search_term)
            params['search'] = encodeURIComponent(search_term);
        return this.http.get(url, { headers, params }).toPromise();
    }
    getAllIaActivitiesByPlayer(template_id) {
        const url = SERVER_URL + `/ia_module/get_all_list_activities/${template_id}`;
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers }).toPromise();
    }
    getRankingByActivity() {
        const url = SERVER_URL + '/crm/get_player_ranking/';
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers }).toPromise();
    }
}
MissionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MissionsService_Factory() { return new MissionsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i3.ConfigService)); }, token: MissionsService, providedIn: "root" });
